import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { GIFT_FINDER_FILTER, NEXT_BACK } from '../../../config/setup/setup';
import { GiftFinderFiltersButton as FinderButton } from './GiftFinderFiltersButton';

export const GiftFinderFiltersButtons = ({ activeKey, onClick }) => {
  const [clickBack, setClickBack] = useState(null);
  const [clickNext, setClickNext] = useState(null);

  const numberOfTabs = Object.values(GIFT_FINDER_FILTER).length;
  const selectedTabId = Object.values(GIFT_FINDER_FILTER).findIndex(
    (value) => value === activeKey,
  );
  const selectedTabValue = (newTab) => {
    return Object.values(GIFT_FINDER_FILTER).find(
      (value, index) => index === newTab,
    );
  };

  useEffect(() => {
    if (selectedTabId === 0) {
      setClickBack(null);
      setClickNext(selectedTabValue(selectedTabId + 1));
    } else if (selectedTabId === numberOfTabs - 1) {
      setClickBack(selectedTabValue(selectedTabId - 1));
      setClickNext(null);
    } else {
      setClickBack(selectedTabValue(selectedTabId - 1));
      setClickNext(selectedTabValue(selectedTabId + 1));
    }
  }, [selectedTabId, numberOfTabs]);

  return (
    <div className="filter-buttons">
      {clickBack && (
        <FinderButton
          onClick={() => onClick(clickBack)}
          orientation={NEXT_BACK.BACK}
        />
      )}
      {clickNext && (
        <FinderButton
          onClick={() => onClick(clickNext)}
          orientation={NEXT_BACK.NEXT}
        />
      )}
      <style jsx>{`
        .filter-buttons {
          overflow: hidden;
          padding: 20px 0;
        }
      `}</style>
    </div>
  );
};

GiftFinderFiltersButtons.propTypes = {
  activeKey: PropTypes.oneOf([
    null,
    GIFT_FINDER_FILTER.BUDGET,
    GIFT_FINDER_FILTER.FOR,
    GIFT_FINDER_FILTER.TYPE,
  ]),
  onClick: PropTypes.func,
};
